<!-- Alerta flotante de monitoreo (15/10/2026): 3 días antes y mientras siga
     vencido, solo para quien puede registrar el corte. -->
@if (visible()) {
  <aside class="alm" [class.alm--vencido]="hayVencidos()" aria-labelledby="almTitulo" aria-live="polite">
    <header class="alm-cab">
      <span class="material-icons alm-ico" aria-hidden="true">notifications_active</span>
      <div class="alm-cab__txt">
        <h2 id="almTitulo" class="alm-tit">Te toca monitorear</h2>
        <p class="alm-sub">{{ resumen() }}</p>
      </div>
    </header>

    <ul class="alm-lista">
      @for (p of visibles(); track p.item.tipo + p.item.id) {
        <li>
          <button type="button" class="alm-item" [class.vencido]="p.proximo.estado === 'VENCIDO'"
                  [title]="p.proximo.detalle" (click)="abrir(p)">
            <span class="alm-item__txt">
              <span class="alm-item__fila">
                @if (p.item.claveMatriz) {
                  <span class="alm-clave" [title]="p.item.nombreMatriz || ''">{{ p.item.claveMatriz }}</span>
                }
                <strong class="alm-folio">{{ p.item.folio }}</strong>
                <span class="alm-estado">{{ p.proximo.texto }}</span>
              </span>
              <span class="alm-desc">{{ p.item.tipo === 'ACTIVO' ? 'Activo: ' : '' }}{{ p.item.descripcion }}</span>
            </span>
            <span class="material-icons alm-ir" aria-hidden="true">chevron_right</span>
          </button>
        </li>
      }
    </ul>

    <footer class="alm-pie">
      @if (restantes()) {
        <button type="button" class="alm-ver" (click)="verTodos()">
          Ver los {{ pendientes().length }} en Gestión de Riesgos
          <span class="material-icons" aria-hidden="true">arrow_forward</span>
        </button>
      }
      <button type="button" class="alm-cerrar" (click)="cerrar()">Cerrar por hoy</button>
    </footer>
  </aside>
}
